// removed by extract-text-webpack-plugin
module.exports = {"InterestRateLegend":"InterestRateLegend__InterestRateLegend__3X8an","table":"InterestRateLegend__table__5DUz4","left":"InterestRateLegend__left__2E0SL","right":"InterestRateLegend__right__2Het9","center":"InterestRateLegend__center__poa-e"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InterestRateLegend/InterestRateLegend.css
// module id = 559
// module chunks = 0